import { render } from "./Overview.vue?vue&type=template&id=348748c9&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import "./Overview.vue?vue&type=style&index=0&id=348748c9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\Desktop\\SMFBackstageBase\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348748c9"]])

export default __exports__